import { PrettyCurrency } from 'components';
import { useTranslations } from 'next-intl';
import { useInvoice } from 'providers/InvoicesProviders/useInvoice';

const TAX_CODES_WITH_AMOUNT = ['1a', '5b'];

export default function InvoiceItems({ invoice: { id } }) {
  const t = useTranslations();

  const { data, isLoading } = useInvoice({ id });

  if (isLoading) return <p className="center-text">{t('billing.loading')}</p>;

  const { invoiceItems } = data;

  return (
    <table className="font-size-print w-100 mb-3 table">
      <thead>
        <tr>
          <th className="invoices__transactions_table__description  !border-0 !border-b-1 !border-b-tertiary-600 bg-tertiary-800 !py-4 !font-medium !text-tertiary-200">
            {t('billing.invoice_items.description')}{' '}
          </th>
          <th className="invoices__transactions_table__ex_tax  !border-0 !border-b-1 !border-b-tertiary-600 bg-tertiary-800 !py-4 !font-medium !text-tertiary-200">
            {t('billing.invoice_items.tax')}{' '}
          </th>
          <th className=" !border-0 !border-b-1 !border-b-tertiary-600 bg-tertiary-800 !py-4 !font-medium !text-tertiary-200"></th>
          <th className="invoices__transactions_table__tax_perc align-right  !border-0 !border-b-1 !border-b-tertiary-600 bg-tertiary-800 !py-4 !font-medium !text-tertiary-200 ">
            {t('billing.invoice_items.total')}{' '}
          </th>
        </tr>
      </thead>
      <tbody>
        {invoiceItems.map(
          (
            { createdAt, currency, netAmount, orderCode, taxRate, taxCode, taxAmount, title },
            i
          ) => {
            const shoudShowAmount = TAX_CODES_WITH_AMOUNT.includes(taxCode);

            return (
              <tr
                className="invoices__transactions_table__item !border-0 !border-b-1 !border-b-tertiary-600 text-tertiary-100"
                key={`${createdAt}-${i}`}
              >
                <td className="!border-0 !px-3 !py-4 !text-tertiary-100">
                  <div className="truncate_block" style={{ maxWidth: '20em' }}>
                    {orderCode && (
                      <>
                        <strong>{`${t('billing.po_code')}: ${orderCode}`}</strong>
                        <br />
                      </>
                    )}
                    {title}
                  </div>
                </td>
                <td className="!border-0 !px-3 !py-4 !text-tertiary-100">
                  {' '}
                  {t(`billing.invoice_items.codes.${taxCode}`, {
                    taxRate: taxRate ? taxRate * 100 : ''
                  })}{' '}
                </td>
                <td className="!border-0 !px-3 !py-4 !text-tertiary-100">
                  {shoudShowAmount ? (
                    <PrettyCurrency amount={taxAmount} currency={currency} />
                  ) : null}
                </td>
                <td className="align-right !border-0 !px-3 !py-4 !text-tertiary-100">
                  <PrettyCurrency amount={netAmount} currency={currency} />
                </td>
              </tr>
            );
          }
        )}
      </tbody>
    </table>
  );
}
